import womensImg from "../../assets/images/myanwan/womens.png";
export default function AboutSection() {
  return (
    <section className="max-w-6xl mx-auto px-5 py-16 ">
      <div className="grid lg:grid-cols-2 gap-8 items-center">
        <div className="relative">
          <img
            src={womensImg}
            alt="Group photo of MYANWEN organization members in traditional green attire"
            className="rounded-lg shadow-lg w-full"
          />
        </div>

        <div className="space-y-6">
          <h2 className="text-[#2E8B57] text-xl md:text-2xl font-bold tracking-tight">
            ABOUT US
          </h2>

          <div className="prose prose-lg text-gray-600">
            <p>
              Myanmar Women Entrepreneurs Network (MYANWEN) is a non-profit,
              non-governmental organization founded on April 2, 2020 by
              successful women entrepreneurs, women professionals, and aspiring
              young women entrepreneurs with the vision to be the leading
              organization empowering and providing key guidance to women-led
              businesses and women across all sectors to support the
              socio-economic development with (6) main objectives.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
